import { useNavigate } from 'react-router-dom';

function Home({ ladies, avails }) {
    const navigate = useNavigate();

    return (
        <div>
            {/* Header Image */}
            <div className="relative h-[50vh] md:h-[70vh] mb-8">
                <div
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-24 p-4 md:p-8">
                    <div className="w-full md:w-1/3 space-y-4">
                        <h1 className="text-3xl sm:text-2xl md:text-3xl lg:text-5xl font-bold text-white text-center md:text-left">
                            Sweet Secrets Brothel
                        </h1>
                        <p className="text-sm sm:text-base md:text-lg text-gray-200 text-center md:text-left">
                            is a high-end, discreet space designed for adults looking to relax, connect, and enjoy themselves in a safe and respectful environment. Located in a stylish, private building, it offers a welcoming atmosphere that feels more like a boutique hotel than anything else. Inside, you’ll find beautifully designed rooms, soft lighting, and a calm, comfortable vibe. Whether you're there for conversation, companionship, or something more personal, everything is handled with care, consent, and total discretion. The girls at Sweet Secrets are professional, friendly, and focused on creating a positive, respectful experience. Everyone is treated with kindness, and every visit is tailored to what you’re looking for—no pressure, no judgment. At its heart, Sweet Secrets is about connection, comfort, and making sure guests feel seen, valued, and respected.
                        </p>
                    </div>
                    <img
                        src="/images/homePage.png"
                        alt="Home"
                        className="h-32 sm:h-48 md:h-3/5 lg:h-4/5 object-cover"
                    />
                </div>
            </div>

            {/* Page Content */}
            <div className="container mx-auto px-4">
                {avails.map(a => (
                    <div>
                        <div className="relative bg-pink-600 text-white px-8 py-2 inline-block font-bold rounded">
                            {a.timeRange}

                            <span class="absolute left-0 top-0 h-full w-3 
               bg-black [clip-path:polygon(0_0,100%_50%,0_100%)]"></span>
                            <span class="absolute right-0 top-0 h-full w-3 
               bg-black [clip-path:polygon(100%_0,0_50%,100%_100%)]"></span>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                            {a.ladies.map((l, index) => {
                                let girl = ladies.find(lady => lady.name == l)

                                if (girl !== undefined) {
                                    return (
                                        <div key={index}
                                            className="overflow-hidden text-center cursor-pointer"
                                            onClick={() => navigate(`/ladies/${girl.name.toLowerCase()}`)}>
                                            <div className="aspect-[221/340] relative overflow-hidden">
                                                <img
                                                    src={girl.images?.length >= 1 ? girl.images[0] : ""}
                                                    alt={girl.name}
                                                    className="absolute inset-0 w-full h-full object-contain transition-transform duration-300 hover:scale-110"
                                                />
                                            </div>
                                            <div className="p-6">
                                                <h2 className="text-md mb-4 text-pink-700 font-semibold">{girl.name}</h2>
                                            </div>
                                        </div>)
                                }
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Home;